import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useAuth } from '@/contexts/AuthContext';
import { PhoneIncoming, Phone, Check, Building2, User } from 'lucide-react';
import { ActiveTxNote } from '@/components/ActiveTxNote';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export const CallbackAlerts = ({ isRTL }) => {
  const { token, isAdmin } = useAuth();
  const [items, setItems] = useState([]);
  const seen = useRef(new Set());
  const headers = { Authorization: `Bearer ${token}` };
  useEffect(() => {
    if (!isAdmin || !token) return;
    const poll = () => axios.get(`${API}/callbacks`, { headers }).then(r => {
      const list = r.data || [];
      if (list.some(c => !seen.current.has(c.id))) {
        try { const ctx = new (window.AudioContext || window.webkitAudioContext)(); const o = ctx.createOscillator(), g = ctx.createGain(); o.connect(g); g.connect(ctx.destination); o.frequency.value = 660; g.gain.value = 0.08; o.start(); setTimeout(() => o.stop(), 400); } catch {}
      }
      list.forEach(c => seen.current.add(c.id));
      setItems(list);
    }).catch(() => {});
    poll(); const iv = setInterval(poll, 5000); return () => clearInterval(iv);
  }, [isAdmin, token]);
  const done = async (id) => { await axios.put(`${API}/callbacks/${id}/done`, {}, { headers }).catch(() => {}); setItems(p => p.filter(c => c.id !== id)); };
  if (!items.length) return null;
  return (
    <div className="fixed bottom-4 start-4 z-[90] w-80 space-y-2" dir={isRTL ? 'rtl' : 'ltr'} data-testid="callback-alerts">
      {items.slice(0, 3).map(c => (
        <div key={c.id} className="rounded-2xl bg-white border border-emerald-200 shadow-2xl p-3" data-testid="callback-alert">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-emerald-50 flex items-center justify-center">{c.kind === 'client' ? <Building2 className="w-5 h-5 text-emerald-700" /> : <User className="w-5 h-5 text-emerald-700" />}</div>
            <div className="flex-1 min-w-0"><p className="text-[11px] text-emerald-700 font-bold flex items-center gap-1"><PhoneIncoming className="w-3 h-3" />{isRTL ? 'طلب معاودة اتصال' : 'Callback request'}</p><p className="text-sm font-bold text-slate-900 truncate" data-testid="callback-name">{c.name || (isRTL ? 'بدون اسم' : 'Unknown')}</p><p className="text-xs text-slate-500" dir="ltr">{c.phone}</p></div>
          </div>
          {c.active_tx?.length > 0 && <div className="mt-2"><ActiveTxNote list={c.active_tx} isRTL={isRTL} compact /></div>}
          <div className="flex gap-2 mt-2">
            <a href={`tel:${c.phone}`} className="flex-1 h-9 rounded-xl bg-emerald-600 text-white text-xs font-bold flex items-center justify-center gap-1" data-testid="callback-call"><Phone className="w-3.5 h-3.5" />{isRTL ? 'اتصل الآن' : 'Call now'}</a>
            <button onClick={() => done(c.id)} className="flex-1 h-9 rounded-xl bg-slate-100 text-slate-700 text-xs font-bold flex items-center justify-center gap-1" data-testid="callback-done"><Check className="w-3.5 h-3.5" />{isRTL ? 'تم الاتصال' : 'Done'}</button>
          </div>
        </div>
      ))}
    </div>
  );
};
